<template>
	<!-- v-if="isHumanReview" -->
	<div class="face">
		<div class="faceBack"></div>
		<div class="faceDataDlo">
			<div class="titleDialog">
				<p>人脸识别</p>
				<i></i>
				<em v-if="!isTest" class="el-icon-close detIcon" @click="isOpenShow()"></em>
			</div>
			<div class="faceDiv" v-if="isSuccessful === ''">
				<p>请衣着整齐，对准摄像头，并正对光源</p>
				<div class="faceData">
					<div class="leftTop"></div>
					<div class="rightTop"></div>
					<div class="leftButton"></div>
					<div class="rightButton"></div>
					<i class="faceDataLine"></i>
					<video autoplay playsinline id="video" width="333" height="333"></video>
					<!-- <canvas id="canvas" width="300" height="300"></canvas> -->
					<div class="faceNumber" v-if="count > 0">{{ count }}</div>
				</div>
				<el-button class="refer-btn" type="primary">人脸识别中...</el-button>
			</div>
			<!--      审核中-->
			<div class="faceDivSuccessful" v-if="isSuccessful === 'audit'">
				<img class="auditImg" src="@/assets/images/auditImg.png" alt="" />
				<p>正在识别中请耐心等待...</p>
			</div>
			<!--      成功-->
			<div class="faceDivSuccessful" v-if="isSuccessful === 'successful'">
				<img src="@/assets/images/faceSuccessful.png" alt="" />
				<p>
					已识别成功
					<br />
					点击下方按钮去开始考试
				</p>
				<el-button class="refer-btn" type="primary" @click="isRouter()">开始考试</el-button>
			</div>
			<!--      失败-->
			<div class="faceDivSuccessful" v-if="isSuccessful === 'failure'">
				<img src="@/assets/images/faceErr.png" alt="" />
				<p>
					{{ msgData }}
					<br />
					请拨打下方电话，联系管理员
					<br />
					023-62652911,023-62652917
				</p>
				<el-button class="refer-btn" type="primary" @click="setSuccessful()">重新识别</el-button>
				<!-- <el-button
          v-if="routerPath === '/participateTest'"
          style="
            margin-top: 10px;
            background-color: #c0c0c0;
            border-color: #c0c0c0;
          "
          class="refer-btn isReturn"
          type="primary"
          @click="setHumanReview()"
          >申请人工审核</el-button
        > -->
			</div>
			<div class="faceDivSuccessful" v-if="isSuccessful === 'equipment'">
				<img src="@/assets/images/faceErr.png" alt="" />
				<strong>浏览器未检测到摄像头</strong>
				<p>1、请确认是否安装可使用的摄像头</p>
				<p class="pButton">2、请确认浏览器是否设置允许本网站调用摄像头</p>
				<el-button class="refer-btn" type="primary" @click="setEquipment()">确定</el-button>
			</div>
		</div>
	</div>
	<!-- <HumanReview
    v-else
    @setHumanReview="setHumanReview"
    :examBasicUuidReview="examBasicUuid"
    @stateName="stateName"
  /> -->
</template>

<script>
// import { getStore, setStore } from "@/utils/localStorage";
// import HumanReview from "@/components/humanReview";
require('tracking/build/tracking-min.js');
require('tracking/build/data/face-min.js');
import { faceServe, getUpExamLog } from '@/api/exam';
import { putObjectBlob } from '@/utils/upload';
export default {
	name: 'face',
	// components: { HumanReview },
	props: {
		isTest: {
			type: Boolean,
			default: false
		},
		examBasicUuid: {
			type: String,
			default: ''
		},
		make_id: {
			type: Number,
			default: 0
		}
	},
	data() {
		return {
			trackerTask: null,
			mediaStreamTrack: null,
			start: true,
			isSuccessful: '',
			isTime: '',
			// isHumanReview: true,
			count: 3,
			routerPath: '',
			msgData: ''
		};
	},

	mounted() {
		this.openCameraFz();
		this.routerPath = this.$route.path;
	},
	methods: {
		openCameraFz() {
			this.openUserMedia();
			setTimeout(() => {
				this.openCamera();
			}, 3000);
		},
		sportsCamera() {
			this.mediaStreamTrack.getTracks()[0].stop();
			this.mediaStreamTrack = null;
		},
		// setHumanReview() {
		//   this.isHumanReview = !this.isHumanReview;
		// },
		setTimeNum() {
			this.count = 3;
			const times = setInterval(() => {
				this.count -= 1;
				if (this.count === 0) {
					clearInterval(times);
				}
			}, 1000);
		},
		stateName() {
			this.$emit('isRouter');
		},
		isRouter() {
			this.$emit('isRouter');
		},
		isOpenShow() {
			this.$emit('isValidationFace');
			this.trackerTask.stop();
		},
		setSuccessful() {
			this.isSuccessful = '';
			this.start = true;
			setTimeout(() => {
				this.openUserMedia();
				setTimeout(() => {
					this.openCamera();
				}, 3000);
			}, 1000);
		},
		setEquipment() {
			if (this.routerPath === '/participateTest') {
				this.$emit('isValidationFace');
				return;
			}
			this.$router.replace('/');
		},
		success(stream) {
			const than = this;
			let video = document.getElementById('video');
			than.mediaStreamTrack = null;
			than.mediaStreamTrack = stream;
			try {
				video.srcObject = stream;
			} catch (e) {
				console.log('访问用户媒体设备失败：', e.name, e.message);
			}
			video.play(); //播放视频
		},
		error(error) {
			this.isSuccessful = 'equipment';
			console.log('访问用户媒体失败：', error.name, error.message);
		},
		getUserMediaToPhoto(constraints, success, error) {
			if (navigator.mediaDevices.getUserMedia) {
				navigator.mediaDevices
					.getUserMedia(constraints)
					.then(success)
					.catch(error);
			} else if (navigator.webkitGetUserMedia) {
				navigator.webkitGetUserMedia(constraints, success, error);
			} else if (navigator.mozGetUserMedia) {
				navigator.mozGetUserMedia(constraints, success, error);
			} else if (navigator.getUserMedia) {
				navigator.getUserMedia(constraints, success, error);
			}
		},
		openCamera() {
			const than = this;
			let tracker = new window.tracking.ObjectTracker('face');
			tracker.setInitialScale(4);
			tracker.setStepSize(2);
			tracker.setEdgesDensity(0.1);
			than.trackerTask = tracking.track('#video', tracker);
			tracker.on('track', event => {
				if (event.data.length > 0) {
					event.data.forEach(() => {
						if (than.start) {
							than.start = false;
							setTimeout(() => {
								this.isSuccessful = 'audit';
								than.isOpen();
							}, 5000);
						}
					});
				}
			});
		},
		openUserMedia() {
			this.setTimeNum();
			if (navigator.mediaDevices.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.getUserMedia) {
				this.getUserMediaToPhoto(
					{
						video: {
							width: 333,
							height: 333,
							facingMode: 'user'
						}
					},
					this.success,
					this.error
				);
			} else {
				alert('你的浏览器不支持访问用户媒体设备');
			}
		},
		imgsrc() {
			let video = document.getElementById('video'),
				canvas = document.createElement('canvas');
			canvas.width = video.videoWidth;
			canvas.height = video.videoHeight;
			canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);

			canvas.getContext('2d').drawImage(video, 0, 0, 333, 333);
			let imgData = canvas.toDataURL('image/png');
			return imgData;
		},
		upCapture(type) {
			let file = this.dataURLtoFile(this.imgsrc(), 'image/png');
			putObjectBlob(file, res => {
				let data = {
					make_id: this.make_id,
					content: res,
					type: 1
				};
				getUpExamLog(data).then(item => {});
			}, null, null, 'image/png');
		},
		async isOpen() {
			let file = this.dataURLtoFile(this.imgsrc(), 'image/png');
			putObjectBlob(file, res => {
				if (!this.isTest) {
					faceServe
						.newPersonVerify({
							exam_id: this.examBasicUuid,
							url: res,
							type: 2
						})
						.then(data => {
							if (data.data.code !== 200) {
								this.isSuccessful = 'failure';
								this.msgData = data.data.msg;
							} else {
								this.isSuccessful = 'successful';
							}
						})
						.catch(() => {
							this.isSuccessful = 'failure';
						});
				} else {
					this.face(res);
				}

				clearInterval(this.isTime);
				this.sportsCamera();
				this.trackerTask.stop();
			}, null, null, 'image/png');
		},
		async face(url) {
			getUpExamLog({
				make_id: this.make_id,
				type: 2,
				content: url
			})
				.then(data => {
					if (data.code !== 200) {
						this.isSuccessful = 'failure';
						this.msgData = data.msg;
					} else {
						this.isSuccessful = 'successful';
					}
				})
				.catch(() => {
					this.isSuccessful = 'failure';
				});
		},
		// async changeData() {
		//   const isOpen = getStore("userInfo");
		//   if (isOpen) {
		//     const isOpenParse = JSON.parse(isOpen);
		//     const changeData = await faceServe.updateLogin({
		//       uuid: isOpenParse.commonUuid,
		//       isPersonVerify: false,
		//     });
		//     isOpenParse.isPersonVerify = false;
		//     setStore("userInfo", isOpenParse);
		//     console.log(changeData);
		//   }
		// },

		dataURLtoFile(dataURI, type) {
			let binary = atob(dataURI.split(',')[1]);
			let array = [];
			for (let i = 0; i < binary.length; i++) {
				array.push(binary.charCodeAt(i));
			}
			return new Blob([new Uint8Array(array)], { type: type });
		}
	}
};
</script>

<style scoped lang="scss">
.face {
	width: 100%;
	height: 100%;
	position: fixed;
	left: 0;
	top: 0;
	z-index: 111;
	display: flex;
	justify-content: center;
	align-items: center;
	background: rgba(0, 0, 0, 0.5);
}
.face .faceDataDlo {
	width: 665px;
	background: #fff;
	padding: 30px 0;
	// height: 600px;
	// margin-top: 10%;
}
.titleDialog {
	display: flex;
	flex-direction: column;
	align-items: center;
	position: relative;
}
.titleDialog p {
	font-size: 20px;
	color: #333;
}
.titleDialog i {
	width: 105px;
	height: 13px;
	@include bgColor('primary');
	margin-top: -12px;
	opacity: 0.37;
}
.faceDiv {
	display: flex;
	flex-direction: column;
	align-items: center;
}
.faceDiv p {
	font-size: 15px;
	color: #333;
	margin: 50px 0 42px;
}
.faceDiv .faceData {
	width: 300px;
	height: 300px;
	overflow: hidden;
	position: relative;
	margin-bottom: 50px;
}
.faceDiv .faceData .faceNumber {
	width: 300px;
	height: 300px;
	background: rgba(0, 0, 0, 0.3);
	position: absolute;
	left: 0;
	top: 0;
	display: flex;
	justify-content: center;
	align-items: center;
	font-size: 80px;
	font-weight: bold;
	color: #fff;
}
.faceDiv .leftTop {
	width: 50px;
	height: 50px;
	border-left: 10px solid #2e58ff;
	border-top: 10px solid #2e58ff;
	position: absolute;
	left: 0;
	top: 0;
}
.faceDiv .rightTop {
	width: 50px;
	height: 50px;
	border-right: 10px solid #2e58ff;
	border-top: 10px solid #2e58ff;
	position: absolute;
	right: 0;
	top: 0;
}
.faceDiv .leftButton {
	width: 50px;
	height: 50px;
	border-left: 10px solid #2e58ff;
	border-bottom: 10px solid #2e58ff;
	position: absolute;
	left: 0;
	bottom: 0;
}
.faceDiv .rightButton {
	width: 50px;
	height: 50px;
	border-right: 10px solid #2e58ff;
	border-bottom: 10px solid #2e58ff;
	position: absolute;
	right: 0;
	bottom: 0;
}
.faceDiv .faceDataLine {
	width: 300px;
	height: 2px;
	background: #2e58ff;
	position: absolute;
	top: 0;
	animation: keyLine 1.5s infinite;
}
.faceDivSuccessful {
	display: flex;
	flex-direction: column;
	align-items: center;
}
.faceDivSuccessful strong {
	margin-bottom: 20px;
	font-size: 15px;
	color: #333;
}
.faceDivSuccessful p {
	font-size: 14px;
	color: #999;
}
.faceDivSuccessful .pButton {
	margin: 5px 0 30px;
}
.faceDivSuccessful img {
	margin: 75px 0 25px;
}
.faceDivSuccessful .auditImg {
	margin: 150px 0 25px;
}
.refer-btn {
	width: 233px;
	border-radius: 50px;
	margin-top: 20px;
}
.isReturn:hover {
	opacity: 0.7;
}
.detIcon {
	font-size: 30px;
	position: absolute;
	top: 10px;
	right: 10px;
	cursor: pointer;
}
.detIcon:hover {
	color: #2e58ff;
}
@keyframes keyLine {
	0% {
		top: 0;
	}
	50% {
		top: 300px;
	}
	100% {
		top: 0;
	}
}
</style>
